import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import styles from './ElementData.styles';
import IconHandler, { IconType } from 'components/common/icon/IconHandler';

interface ElementDataRowLabelProps {
    children?: ReactNode;
    icon?: IconType;
    iconIndent?: boolean;
}
export default function ElementDataRowLabel(props: ElementDataRowLabelProps) {
    const { children, icon, iconIndent } = props;

    if (!icon && !children) return null;
    return (
        <Stack
            direction={'row'}
            sx={styles.labelHolder}
            className={`element-data-row-label ${!children ? 'element-data-row-label--only-icon' : ''}`}
        >
            {(icon || iconIndent) && (
                <Box sx={styles.labelIcon} className={'element-data-row-label__icon'}>
                    {icon && <IconHandler icon={icon} />}
                </Box>
            )}
            {children && <Box sx={styles.labelText}>{children}</Box>}
        </Stack>
    );
}
